import { render, staticRenderFns } from "./CardSharePairCode.vue?vue&type=template&id=6ce4dfac&scoped=true"
import script from "./CardSharePairCode.vue?vue&type=script&lang=js"
export * from "./CardSharePairCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4dfac",
  null
  
)

export default component.exports